<template>
    <Dialog modal
            :visible="isAddAlertDialogOpen"
            v-model:visible="isAddAlertDialogOpen"
            :header="__('Adding alert')"
            :style="{ width: width }"
            :unstyled="false"
            :pt="dialogPt">
        <AddAlertForm :formProps="{ source_table, source_id }"
                      v-model:isAddAlertDialogOpen="isAddAlertDialogOpen">
        </AddAlertForm>
    </Dialog>

</template>

<script setup>
import { ref, watch } from 'vue'
import AddAlertForm from '@app/Data/Alert/AlertAddForm.vue'
import Dialog from 'primevue/dialog';
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    formProps: Object,
})

const dialogPt = {
    header: { class: 'form-header' },
    content: { class: 'form-body' },
};

const isAddAlertDialogOpen = defineModel('isAddAlertDialogOpen')
const width = ref(props.formProps.width ?? '50%');
const source_table = ref(props.formProps.source_table ?? null);
const source_id = ref(props.formProps.source_id ?? null);

// -----------------------------------------------------

watch(
    () => [props.formProps.source_id, props.formProps.source_table],
    ([newSourceId, newSourceTable]) => {
        source_id.value = newSourceId ?? null;
        source_table.value = newSourceTable ?? null;
    }
)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
